import { ApiClient } from "../../../lib/ApiClient";
import { useGenericSWR } from "../../../lib/useGenericSWR";

const apiClient = new ApiClient();
const apiEndpointBase = '/identity/2fa/manage';
const pathEnableAuthentication = apiEndpointBase + '/authentication';
const pathEnableAuthenticator = apiEndpointBase + '/enableAuthenticator';
const pathResetAuthenticator = apiEndpointBase + '/resetAuthenticator';
const pathRemoveAuthenticator = apiEndpointBase + '/removeAuthenticator';
const pathForgetMachine = apiEndpointBase + '/forgetMachine';
const pathResetAuthenticatorRecoveryCodes = apiEndpointBase + '/resetRecoveryCodes';
const pathResetSms = apiEndpointBase + '/resetSms';
const pathSendSms = apiEndpointBase + '/sms/send';
const pathVerifySms = apiEndpointBase + '/sms/verify';
const pathForceMfa = apiEndpointBase + '/forcemfa';

const useManage2faAuthenticator = (swrOptions = {}) => {
    return useGenericSWR(pathEnableAuthenticator, apiClient, { ...swrOptions });
};

const useManage2faAuthentication = (swrOptions = {}) => {
    return useGenericSWR(pathEnableAuthentication, apiClient, { ...swrOptions });
};

const useForceMfaStatus = (swrOptions = {}) => {
    return useGenericSWR(pathForceMfa, apiClient, { ...swrOptions });
};

const enableAuthenticator = (values) => {
    return apiClient.poster(pathEnableAuthenticator, values);
};

const resetAuthenticator = () => {
    return apiClient.poster(pathResetAuthenticator);
};

const removeAuthenticator = () => {
    return apiClient.poster(pathRemoveAuthenticator);
};

const forgetMachine = () => {
    return apiClient.poster(pathForgetMachine);
};

const resetAuthenticatorRecoveryCodes = () => {
    return apiClient.poster(pathResetAuthenticatorRecoveryCodes);
};

const resetSms = () => {
    return apiClient.poster(pathResetSms);
};

const sendSms = async (values) => {
    return await apiClient.poster(pathSendSms, values);
};

const verifySms = (values) => {
    return apiClient.poster(pathVerifySms, values);
};

const mutateManage2fa = () => {
    apiClient.mutateFetchUrls();
};

export {
    useManage2faAuthentication,
    useManage2faAuthenticator,
    useForceMfaStatus,
    enableAuthenticator,
    resetAuthenticator,
    removeAuthenticator,
    forgetMachine,
    resetAuthenticatorRecoveryCodes,
    resetSms,
    sendSms,
    verifySms,
    mutateManage2fa
};